import { ID, Locales } from '@griply/types';

import { FirestoreInstance } from '../types/firestore';
import { FirestoreCollections } from '../types/firestore-collections';

export type CreatePushTokenOptions<
  TDocRef = unknown,
  TFieldValue = unknown,
  TDb = FirestoreInstance,
> = {
  userId: ID;
  token: string;
  type: string;
  platform: string;
  version: string;
  timezone: string;
  language: Locales;
  db: TDb;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  setDoc: (
    ref: NoInfer<TDocRef>,
    data: Record<string, unknown>,
  ) => Promise<void> | void;
  serverTimestamp: () => TFieldValue;
};

export const createPushToken = async <
  TDocRef,
  TFieldValue,
  TDb = FirestoreInstance,
>({
  userId,
  token,
  type,
  platform,
  version,
  timezone,
  language,
  db,
  doc,
  setDoc,
  serverTimestamp,
}: CreatePushTokenOptions<TDocRef, TFieldValue, TDb>): Promise<void> => {
  if (!userId || !token) {
    return;
  }
  const ref = doc(db, FirestoreCollections.FcmTokens, token);
  await setDoc(ref, {
    token,
    uid: userId,
    type,
    platform,
    version,
    timezone,
    language,
    updatedAt: serverTimestamp(),
  });
};
